import { knAuthAxios } from "@/lib/kn-axios";
import axios from "axios";

const AuthRemoteDataSource = {
  login: (request) => knAuthAxios.post("api-key/user/login/dep", request),
  register: (request) => knAuthAxios.post("api/relatives/register", request),
  relatives: (token) => knAuthAxios.get(`api-key/relatives/${token}`),
  createUserFromRelative: (request) =>
    knAuthAxios.post("api-key/users/saveRelative", request),
  userRelatives: (request) =>
    knAuthAxios.post("/api-key/users/saveRelative", request),
  relativesStatus: (request) => knAuthAxios.post("api-key/relatives", request),
  acceptNoticePrivacy: (request) =>
    knAuthAxios.post(`api-key/userAcknowledgement/termsAndConditions`, request),

  validationUserName: (userName) =>
    knAuthAxios.get("api-key/users/existUserName", {
      params: { userName: userName },
    }),
  getIp: () => axios.get("https://api.ipify.org?format=json"),
  retrievePassword: (request) =>
    knAuthAxios.post("api/relatives/retrievePassword", request),
};

export default AuthRemoteDataSource;
